import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { TipStepInterface, setEditId, setEditError, selectTipStepById } from "../../../store/mine_craft/tipStepsSlice";
import { updateTipStep, fetchTipStep } from "../../../actions/mine_craft/tipStepsActions";
import { objToFormData } from "../../../helpers/FormHelper";

import Form from './_partials/_Form';
import DrawerRight from "../../../componets/DrawerRight";
import AlertBlock from "../../../componets/AlertBlock";

const Edit = () => {
  const dispatch  = useAppDispatch();
  const location  = useLocation();
  const id: any   = useAppSelector(state => state.mineCraft.tipSteps.editId);
  const error     = useAppSelector(state => state.mineCraft.tipSteps.editError);
  const tipStep   = useAppSelector(state => id ? selectTipStepById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchTipStep(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(setEditId(null));
  }, [location, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: TipStepInterface) {
    handleSave(data).catch(console.error);
  }

  function getLocaleRules() {
    const localeRules: any = {};

    if (tipStep) {
      tipStep.empty_locales.forEach(key => localeRules[key] = { blank: false });
    }

    return localeRules;
  }

  async function handleSave(data: TipStepInterface) {
    const rules         = { title_translations: getLocaleRules() };
    const formData: any = objToFormData(data, rules);
    const resultAction  = await dispatch(updateTipStep({ id, data: formData }));

    if (updateTipStep.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-tipStep'>
        <h6 className="v-content-label">Edit TipStep</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        {tipStep && <Form onFinish={onFinish} params={tipStep} />}
      </div>
    </DrawerRight>
  )
}

export default Edit;
